<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands =[
  {
    "num_cand": "U2FsdGVkX1/vhDJbtRWYeAC25Ju4DZhfsXKIfOBT7rk=",
    "cpf": "U2FsdGVkX18u4fKtt+wFXEtsk82VkefL1268wkUsy98="
  },
  {
    "num_cand": "U2FsdGVkX19GN+tFQs8BcGh0Ah13Mj+XjZFtImzGTsk=",
    "cpf": "U2FsdGVkX18pb436oDpkFy+vSjj2cedwSfJea07XlJE="
  },
  {
    "num_cand": "U2FsdGVkX19riF9iuVMqK0FcsaLHgGX3rxEOGDvw9b8=",
    "cpf": "U2FsdGVkX1/KUnII5RngfHoL4iy3G+C9Jm+siYJKcts="
  },
  {
    "num_cand": "U2FsdGVkX19x6t99frKEysQq6rCxw0I2g5WYLV83uuQ=",
    "cpf": "U2FsdGVkX18k+Twnbm8t4+kqhkEFWMUV0e2CcZS7O+8="
  },
  {
    "num_cand": "U2FsdGVkX19ke75C8oK8Lfi5w7lXbSpQzg/Kb6TFGFM=",
    "cpf": "U2FsdGVkX1/RM4uI2BeddV+tDueevAOpW13yJbO3R7Q="
  },
  {
    "num_cand": "U2FsdGVkX1/0KilRF/WOwMJ+20qQc2mE6CXMKNTC/us=",
    "cpf": "U2FsdGVkX183OKXtwrzELVHWqmlaVBtfL7AO/QZ/qBc="
  },
  {
    "num_cand": "U2FsdGVkX198YzPGrfoiBxaHUv2e5Byee0T/qgEdS9I=",
    "cpf": "U2FsdGVkX19A9aJCeWCHW/nMUYSqx4u+Qfl08szHreU="
  },
  {
    "num_cand": "U2FsdGVkX1/y0MttTQenyW6r8jJxUy8690zD9UQ51OM=",
    "cpf": "U2FsdGVkX185XbnNNeWbrNu/CAYPCZar5boxaBdxMFk="
  },
  {
    "num_cand": "U2FsdGVkX1/2jTXV5o1zqMoUAiX4pcf8f0Jr0RNPHq8=",
    "cpf": "U2FsdGVkX1+8NGA0IkCWWlihcQtW2QIZcJHh9+7KRPA="
  },
  {
    "num_cand": "U2FsdGVkX18YC72346PJ6YFRlQmbTGWoU9h28VBVLBg=",
    "cpf": "U2FsdGVkX180AoA0LFiXd43WxMWLL6wUhb3fiyXRCGc="
  },
  {
    "num_cand": "U2FsdGVkX1+eZ4Ttxp9h0OwsMfaQ07IdjsP5HIlVjNc=",
    "cpf": "U2FsdGVkX18bNAoUDb4RWkCRUrBwonGpJ+weayfctTU="
  },
  {
    "num_cand": "U2FsdGVkX19eT88/yu09AqFZRZ1gip5lLhf+Gbfm520=",
    "cpf": "U2FsdGVkX18dBlHsV8D0+uyr8T2dFJq6BagLasSDfVw="
  },
  {
    "num_cand": "U2FsdGVkX19agn8k5o2hQ0IkGQ+o2as0JnDd+gh2ovI=",
    "cpf": "U2FsdGVkX1/fCztBbLSdw4AncUGAxqBcf73iZL4QFvA="
  },
  {
    "num_cand": "U2FsdGVkX1/CJdEgYywYmAfi7ShUTG2UJP/+Xt3MnaQ=",
    "cpf": "U2FsdGVkX18uYg+gzuugf749EwqwnT8NLt5RNHj9ki4="
  },
  {
    "num_cand": "U2FsdGVkX1/2hhzAZc7weVA8aC8Ans6nY4b53qKSHRA=",
    "cpf": "U2FsdGVkX1+dyfiJ1MbL6oXa6I0U060mHB+Zm6wn/T4="
  },
  {
    "num_cand": "U2FsdGVkX1/5wfAixK5UJQnDiUdHzXg+IETvRAvWhVM=",
    "cpf": "U2FsdGVkX1+6QRPmGdQqPl9QhiSczM1q5b7JX/2xtz8="
  },
  {
    "num_cand": "U2FsdGVkX19hqJFzAIDGcuqyoLzJA8IwWwI20xAG7OE=",
    "cpf": "U2FsdGVkX19WMbw8Bj6UwswZ3o2+UDsN12HSJq5pUrM="
  },
  {
    "num_cand": "U2FsdGVkX1+/PBS8XFf3nZ+GEiChdVBD6NwUWypARxM=",
    "cpf": "U2FsdGVkX1/QEcbj3vmKwkDuAAlVKeyorPjMAyzy/co="
  },
  {
    "num_cand": "U2FsdGVkX192scB4p4ryL1qC0YMg10u5PougytKTcWI=",
    "cpf": "U2FsdGVkX199z4DUIKF2B96d1Fq3Psdt41x5GPy4stU="
  },
  {
    "num_cand": "U2FsdGVkX1+yBlCaeuJClfmHYVFosciXfWZcx4V+BSU=",
    "cpf": "U2FsdGVkX19AGpw51JhWHvtfD20Qa3mtlGSFbYS5UT4="
  },
  {
    "num_cand": "U2FsdGVkX1+sKdCHOXCq+z05mvhZVfoginfdOc02DQ4=",
    "cpf": "U2FsdGVkX192KpfNm1zsCWrdR3JNTpb0VuCXokXbKjg="
  },
  {
    "num_cand": "U2FsdGVkX19EgyUMGX2yezPExjhfOveTQcXnkC7pchU=",
    "cpf": "U2FsdGVkX1/kiFDjg14Lv5P01oNoMcPKJF/U4Jv8KTo="
  },
  {
    "num_cand": "U2FsdGVkX19mFwe16LLSrjYTnoGkIt2O7XnuOBvEiPo=",
    "cpf": "U2FsdGVkX19i9ZMBe27EOemhRBnGvg1LXHW6HIq4u1k="
  },
  {
    "num_cand": "U2FsdGVkX1+g43XKAP/PUgkWiOm5hxVVBv/JjsQOuZQ=",
    "cpf": "U2FsdGVkX1/x0mledo6xrP0StM7cbc7v2xdeg49GqCE="
  },
  {
    "num_cand": "U2FsdGVkX18+yMK68QyYNne1BR1bhl6PxV+P+9NqnMw=",
    "cpf": "U2FsdGVkX19NhtWf9R7k6rHpNfoqOnIH9bMG4MQGi1A="
  },
  {
    "num_cand": "U2FsdGVkX19Aa4QFZ+qVUxgBOHG6ntxCcfy3FxGXJfc=",
    "cpf": "U2FsdGVkX1/RyTQH2EQYg4+5v4SgVuPskx0+aYfva00="
  },
  {
    "num_cand": "U2FsdGVkX1+fAAnXoOBQetJGjFxN37Mwuh1CgqD9yW4=",
    "cpf": "U2FsdGVkX19fGdN3n6xL1LCnQ+xnl7nRYlZhHcJnz/4="
  },
  {
    "num_cand": "U2FsdGVkX1+OUvlnGIhtbZHoPIBObrA/0ERHlNuw1xQ=",
    "cpf": "U2FsdGVkX197I+WJtKnOaN4CpW82BlPK4aS5W2FpMg4="
  },
  {
    "num_cand": "U2FsdGVkX18qiaQ7B32akbWKXJn/cA9cIawzPFTqKjE=",
    "cpf": "U2FsdGVkX18LaPAhFJbs5GFR4jVVi3e9ipLuz09QGoc="
  },
  {
    "num_cand": "U2FsdGVkX1+bCthhH0zpCHSAlZFsI1yAZ2riala/2ig=",
    "cpf": "U2FsdGVkX19ssWo9fYRPoeNrbVTsaPzaUvdNrY1/1uI="
  },
  {
    "num_cand": "U2FsdGVkX19KPJk/ZBl1K+C5aSItKPuOET9UMTYOevQ=",
    "cpf": "U2FsdGVkX18zNSxUYPYhREZ5nvMTEab8Jc/FQQcuB2o="
  },
  {
    "num_cand": "U2FsdGVkX1/MLenp0a2sVRrDxsZe0DOofXrtzZJPffc=",
    "cpf": "U2FsdGVkX1+el63ttDmy+JHcSkyMgPxluxUHFJz/rJ8="
  },
  {
    "num_cand": "U2FsdGVkX1/oog30lM6rpLWxk4cGCZYfCs+zCriUXTM=",
    "cpf": "U2FsdGVkX1+lh2D9rAPqFW4eHERBtpQERaRLLsRmtDQ="
  },
  {
    "num_cand": "U2FsdGVkX1+7W8Qr+/eD1rvb0KLfbZY9Ew5IwtSe2PU=",
    "cpf": "U2FsdGVkX183scJ2aUL6ZyHi7UIJANNt1nH5MZuYWEI="
  },
  {
    "num_cand": "U2FsdGVkX18yD2L4WK1RHuYlGLLUnK/juUFBpcPrIoc=",
    "cpf": "U2FsdGVkX186qCK0HKcJOSFlSGQILrc73rm2Bhs4GrA="
  },
  {
    "num_cand": "U2FsdGVkX1/FrPMjVhgEE9RPGa6V67bQQLhu4TNy1gY=",
    "cpf": "U2FsdGVkX18JpI4LSD5otfGqhamkRA0KdsmaS7rUQ9A="
  },
  {
    "num_cand": "U2FsdGVkX1+JvIw2ckfbr82Hf5cRPV6LZw6oxLoQT/8=",
    "cpf": "U2FsdGVkX19Dea2ChBpT3/xVZRorWZMVXoyQO9S6+W4="
  },
  {
    "num_cand": "U2FsdGVkX1+CjSWrADOvIIfYg5CcF/q+vRNzq6sByfQ=",
    "cpf": "U2FsdGVkX1/l0MF/jYOozz0L7Bq3wDs3+H3HsrXChiQ="
  },
  {
    "num_cand": "U2FsdGVkX18otswJezMJ1RT7eKOrxtZu5JgChvKvPxc=",
    "cpf": "U2FsdGVkX1+S/PfU5O6me3BfIjQXyUX9c7cHzWnB5oA="
  },
  {
    "num_cand": "U2FsdGVkX1+RMt5bEXLtOzN7TzJJ4432axWt0kYSTFk=",
    "cpf": "U2FsdGVkX18Zm5a6/qc07uNlepi/UF6h+yK5YTQYqvc="
  },
  {
    "num_cand": "U2FsdGVkX19hgmpgd/HLtRJlIDViXTTd+ejh0givowI=",
    "cpf": "U2FsdGVkX1+agt7rMll9S9EK0sQJsPAHbbv/oEdpr1g="
  },
  {
    "num_cand": "U2FsdGVkX1+lZ9utF78fhvgS35lb0MCj4gyld2EhemY=",
    "cpf": "U2FsdGVkX1/4NZZQhywD05J3qsopnEGdlNfnq1bzDf0="
  },
  {
    "num_cand": "U2FsdGVkX1/y81L4m7Sq4rOgSqY1sg2stFwjEKw4Yto=",
    "cpf": "U2FsdGVkX19dvfGTtLs7IygfKCeAv0i9lDT4gdUQgL8="
  },
  {
    "num_cand": "U2FsdGVkX186rxvv8Ib/3PggFaKxOzFsqiGx1V/7E4U=",
    "cpf": "U2FsdGVkX19ON2CfkQFIaQEMIG8obFYN+jHj01dD8xc="
  },
  {
    "num_cand": "U2FsdGVkX1/bMWNNe+2LLGGHAG+HaQ2/xbnxxU401Gs=",
    "cpf": "U2FsdGVkX1+x4WiPP2xd+iS2zjIKLWPjC1tpLKQ6UNo="
  },
  {
    "num_cand": "U2FsdGVkX1+CPsUg6PgWHHUtS6vRI1HDn04tQ9T206o=",
    "cpf": "U2FsdGVkX19+vnlaAL4mc12uvMfwydNzR8TQKJYODIs="
  },
  {
    "num_cand": "U2FsdGVkX183Oue+voW7a44Iqow8A/i8koZvqQ5toug=",
    "cpf": "U2FsdGVkX18Od30SAZHmbrUvX6lUHki/gSOu3iJ5kwE="
  },
  {
    "num_cand": "U2FsdGVkX18O7lLW8HU/sqK9NfyvpEnlp/IO0bIhiLw=",
    "cpf": "U2FsdGVkX19ou/OBxUk3Szu0W6aKvODcbuCnUCkq5VI="
  },
  {
    "num_cand": "U2FsdGVkX1+pb8N9yWE/msnslsKnIVNBGwwGwCCrjd0=",
    "cpf": "U2FsdGVkX1+oKvqGB3t95WMb+StBEflqvpEMZwiYNPo="
  },
  {
    "num_cand": "U2FsdGVkX19OM7lREPOgqlMd490RIVj5Kixl+mQbdM0=",
    "cpf": "U2FsdGVkX19kgvf35OrqJJnmqyt/4gLNU62SjlIIUz4="
  },
  {
    "num_cand": "U2FsdGVkX1+0vpXfXHr6KXX0bGRPmILf5hlgKJ7KtwI=",
    "cpf": "U2FsdGVkX1++Nn5xpOYG9Dj72nSIxtLDDAcpZSF4VIs="
  },
  {
    "num_cand": "U2FsdGVkX1+Ey0t8tr1fbxCoe2ZcJ1xaZItcxjJIwzQ=",
    "cpf": "U2FsdGVkX1/eMPtx6OP5BjJCnh8gCrZV5BBVvBzq//A="
  },
  {
    "num_cand": "U2FsdGVkX1839P8AFB2l/LvIMgVcU65l7LyrHaHHuNI=",
    "cpf": "U2FsdGVkX1/s3Urud3bl64fhi6/e3s9Gda/F1DWfen0="
  },
  {
    "num_cand": "U2FsdGVkX1+lNfg4Fv8wevXG9iu5IsdlR3nwomnoEPE=",
    "cpf": "U2FsdGVkX18cn69UWa/jPR5x4AGz5kyNgItQCqchrUs="
  },
  {
    "num_cand": "U2FsdGVkX1+hZAID4hOLhu7U+kS22fDR1z6IQfEMl6o=",
    "cpf": "U2FsdGVkX1+O6hbmtPYtRwcH3WxkVdwNJ2DaIavwUiU="
  },
  {
    "num_cand": "U2FsdGVkX1+OR2BJTLMa7QOOfyfYk690UFeR6i9KFEI=",
    "cpf": "U2FsdGVkX1/jZj/8FzolIM3XhHK8VterhiOT17eTb9Y="
  },
  {
    "num_cand": "U2FsdGVkX19J79cw4s1NKENpZd4xtYJTAAF6aEQZ1Ug=",
    "cpf": "U2FsdGVkX19sg0QTJs95qHYJExGzj5xtzEPgybge9lI="
  },
  {
    "num_cand": "U2FsdGVkX1/hi9rlCCuPXdGso7qKaGDSuOd67lzKAOw=",
    "cpf": "U2FsdGVkX1+kW7lebfW3iO0pVw62qbcBPZ5tkFNM6wI="
  },
  {
    "num_cand": "U2FsdGVkX1+c8vBa6yLAwfpKAN0BlpToK6rfxz1i5NM=",
    "cpf": "U2FsdGVkX19rUYC2ZxCxHQROj2XAkNsV1flSRzsnrBU="
  },
  {
    "num_cand": "U2FsdGVkX19JW2G88/rPNmHsIlzlO/X9wTV+/67IF7E=",
    "cpf": "U2FsdGVkX1++XBP4EEg8xYeve+12RzS1wfJS0Ls4Z84="
  },
  {
    "num_cand": "U2FsdGVkX1+tIC5DyLAn/d9InMXF3a+sBoJ2mZGgQb0=",
    "cpf": "U2FsdGVkX1/1CFYdawSuQrZ1vUjYWMi9E5b1CQjmgs4="
  },
  {
    "num_cand": "U2FsdGVkX18gJGHJj35C/tyF+4UcIJNq1TzP/Uvd8qw=",
    "cpf": "U2FsdGVkX19fN6YZLWYzunsG/Zh+jLr89KdITwUqH7Y="
  },
  {
    "num_cand": "U2FsdGVkX1+3mGKh+GlmLs0OhPAaakK6fu/ARo7i+Yk=",
    "cpf": "U2FsdGVkX19MCt1NxG15KfQcPBJqYMOuQKKVSTg+mSI="
  },
  {
    "num_cand": "U2FsdGVkX18xx2Z6rcm5E1/RnmcH9UW2XLe0gCepLK0=",
    "cpf": "U2FsdGVkX18Rz6dGP0ilibp9vFrP+MORBFcc2ONLBdE="
  },
  {
    "num_cand": "U2FsdGVkX1/BhQyd53FY00sYMLT/DJwnLAUVrDNPgVM=",
    "cpf": "U2FsdGVkX197Ej60QoPUu6WQFz94Gq0y3YSmEo4MXEA="
  },
  {
    "num_cand": "U2FsdGVkX1927HgoFNW1gpDliBbx9lggDJdaAI3mWZE=",
    "cpf": "U2FsdGVkX19JSBG82USJ0q0IbOig+4IvP23Oy0Knt3s="
  },
  {
    "num_cand": "U2FsdGVkX19NSyrXMdLwQ2w1W3thi2KSw7iIvWS0J3M=",
    "cpf": "U2FsdGVkX1+iYGJEC4wNZGuvBNIVMFWUJi4vZL8qYl0="
  },
  {
    "num_cand": "U2FsdGVkX1+3vPkPLUlVvXK40l2zJmwr7dDi4C3VVR0=",
    "cpf": "U2FsdGVkX1/fAeQUVkXHGqa+t3d0zWofIFemenxCxQU="
  },
  {
    "num_cand": "U2FsdGVkX1/krEJZqInH7a3OeOGN+DL30HPvbQ/zlbQ=",
    "cpf": "U2FsdGVkX1/SsESi2VYYEazWiBwwzwesNYpLU/jjjSQ="
  },
  {
    "num_cand": "U2FsdGVkX18+Xo5oz8U1V0hYWk+5yYYfyJBT0E1D6M4=",
    "cpf": "U2FsdGVkX19owY0AW5GZSEYf57v3UVhBU/q5RYaP/RI="
  },
  {
    "num_cand": "U2FsdGVkX1/M4MBWfuqQhDO59i1OaTN0oU1LKZrKv+E=",
    "cpf": "U2FsdGVkX1+YAiDFKG+1IzPR1I49LCOg1jrZsWVWZaQ="
  },
  {
    "num_cand": "U2FsdGVkX19f5oJuMXQonLb50dsm5fBMtibazY8MwPc=",
    "cpf": "U2FsdGVkX18PASohG4k+t3JV4WhnsvUrxkhiaAKQiPg="
  },
  {
    "num_cand": "U2FsdGVkX18c7z0Sjz1x3K4+hU6oiqy+mRB3sQ8VuC4=",
    "cpf": "U2FsdGVkX18NZklU7Trcxs6AgEB+qSkpmYRWCvp96LE="
  },
  {
    "num_cand": "U2FsdGVkX189dnV9SzC9IcEFeZAdjW+VuJOBmWHKZi8=",
    "cpf": "U2FsdGVkX1/rvYE8rD5u+wzG3I/rQ43/NvtE16Y6PeI="
  },
  {
    "num_cand": "U2FsdGVkX1+FzkW+IpFoFHg5QmrN4pGuyN7cXrvu4Bk=",
    "cpf": "U2FsdGVkX1+1Cqax7Ld1fO+a22EPK4q6AOknBjTAte8="
  },
  {
    "num_cand": "U2FsdGVkX1+G/B7Yx6ynVRQsZTvuJSv5wNJ/9w1Jy88=",
    "cpf": "U2FsdGVkX18Y7sYVliRmB/CnzjQMT+rpB7DNNdNJxJg="
  },
  {
    "num_cand": "U2FsdGVkX19zh2W23gUPrA78j9cypGaFTQ27Yp6eDgY=",
    "cpf": "U2FsdGVkX1/oRG97lnmARUeuC73cfonb086QQqSXGOY="
  },
  {
    "num_cand": "U2FsdGVkX19O/mCmZES5dgALo48mkHTSgaazCQd0fbI=",
    "cpf": "U2FsdGVkX18vTyd9wBs9BJjJyFMwKtF2TOcPR9I4ovE="
  },
  {
    "num_cand": "U2FsdGVkX1+lPICRm3xtCCYcAnJ5VP655f+EL4C5EYI=",
    "cpf": "U2FsdGVkX19m0yzHQtq93k6mxG4aInYeCaMFRsgIxJo="
  },
  {
    "num_cand": "U2FsdGVkX1+PgOGivM6BQwlQ/7J7XXZaz+lsotlEsWA=",
    "cpf": "U2FsdGVkX1+JqZxBU9Cw9/cCZfk1pw61lE0vqwwxL44="
  },
  {
    "num_cand": "U2FsdGVkX18lk6gYd2RCmy0I4JLuSe74D3U/F2V02qg=",
    "cpf": "U2FsdGVkX1/jLC+VomcvVRVV5JINVYXSl49THCyCSmU="
  },
  {
    "num_cand": "U2FsdGVkX1//6ZqhD7Nrge4QJ4D2T2Ea4SD4mERpe8Q=",
    "cpf": "U2FsdGVkX188yRwI5Mrw/PaLkSR0oqCw4XkmBBHLRCE="
  },
  {
    "num_cand": "U2FsdGVkX18EN7UP/CBA8VZCzNc1BvPBEiwr34EL8ZE=",
    "cpf": "U2FsdGVkX1/keeYtw5gKeyGRNdwisAl8gPakD4a6sOI="
  },
  {
    "num_cand": "U2FsdGVkX18XudXruB6StSqToZRTKk9h4tH3yGYCAsc=",
    "cpf": "U2FsdGVkX19wUjrX6KHWCaT5v3wSF3WJEk6YC7ntdpI="
  },
  {
    "num_cand": "U2FsdGVkX1+tx7x4VkKQpGIaX8fQr+CQX+2sIne6jBM=",
    "cpf": "U2FsdGVkX188EqTrWsybqtrCsnJdBxGmM+uUHkm9+0U="
  },
  {
    "num_cand": "U2FsdGVkX18OTu/tYnXwbkw3tr5lQOQcYa3SLpLoO0g=",
    "cpf": "U2FsdGVkX1997eDr3GRzOgVXxGMD4mWniZoWLL4Bv10="
  },
  {
    "num_cand": "U2FsdGVkX1/aKIS82wbZcZZGvFKhm6yR7DsMndu+kEQ=",
    "cpf": "U2FsdGVkX18FPY157ma2p6fuFTap25aewwMkRXOqD7g="
  },
  {
    "num_cand": "U2FsdGVkX183rLoFDZvkZpWYZoAAEfLJWSAgJeCgq8c=",
    "cpf": "U2FsdGVkX19y848qKSUUdZaFnSQRXhgHFSJDkAtQBbg="
  },
  {
    "num_cand": "U2FsdGVkX18eb35lMkT0VNWCjhJZC19azr4sI2YQdKQ=",
    "cpf": "U2FsdGVkX1/FjMDJBbC5A2qf3vhp3VGowOWDPFCwXvg="
  },
  {
    "num_cand": "U2FsdGVkX19/64DXTLRWyPmfjUHvRQKlmuMjR8xskbc=",
    "cpf": "U2FsdGVkX19Yx2uI3GaALQb4faSNw45tOjkbwZttuVQ="
  },
  {
    "num_cand": "U2FsdGVkX18YdxMdSnL/LTbitwkoRL3VmdQarCwNmUw=",
    "cpf": "U2FsdGVkX19LXnlCpfOpAkb48+9cyQnMTB8hgVjFk7s="
  },
  {
    "num_cand": "U2FsdGVkX1/FcVYEqJYTFQHxTCMSGRKl+jlkFIqt3TA=",
    "cpf": "U2FsdGVkX1/cBxlhZCy5O2olEdZ49CvbqW+G/o8h0mw="
  },
  {
    "num_cand": "U2FsdGVkX1+8YX8gvSRfgxkGE49NHaw6l+g13UC0GpY=",
    "cpf": "U2FsdGVkX1/xgyo4BZgLw7OKub2s8O9hmiuLv4r2DL0="
  },
  {
    "num_cand": "U2FsdGVkX1+nqi9GYHbHyrNTMVstsDEjb2h4/+2Iap8=",
    "cpf": "U2FsdGVkX19OSZV5mU+/EbTzcLB1rIARZ8t3y2iv+R8="
  },
  {
    "num_cand": "U2FsdGVkX1/8iYgS6X+tiLzQflQqLqfB9VGFCKueQWY=",
    "cpf": "U2FsdGVkX1/dm1V7FYXM2V+rKKhclL4kUHBuFzQOGno="
  },
  {
    "num_cand": "U2FsdGVkX19pKr+hAO/4EPv4lcvwDDXh5VcAvIVpb4U=",
    "cpf": "U2FsdGVkX1/aLFdbDu94AOA/wfkdNbTh/Jp3+cFdfBw="
  },
  {
    "num_cand": "U2FsdGVkX196rQoirc3orT+uNm4whR61/xUcTtiIttI=",
    "cpf": "U2FsdGVkX1/UaZ9b6RSarWeaOQvaR9x56SSGW7ZCHMg="
  },
  {
    "num_cand": "U2FsdGVkX19SumqkhnNx4rDzQ4myIYt93bthc1GW3lY=",
    "cpf": "U2FsdGVkX1+3y2foTYMMThcljCO+cCSpSey6FAfj3yQ="
  },
  {
    "num_cand": "U2FsdGVkX1/TVBXYa4mVIMaWct7hV+D1A8kCkYccfVA=",
    "cpf": "U2FsdGVkX1/LNSHaR0WO62iVTS6T1eTHpwdA2Q0vDy4="
  },
  {
    "num_cand": "U2FsdGVkX1+G7omJpYwDRlsuTmZ4VBlK+IQydxxoOP0=",
    "cpf": "U2FsdGVkX1/y2tsPyQB4pPtY2vSkpZxkYpLiq3EWYQA="
  },
  {
    "num_cand": "U2FsdGVkX1/Px8nH45/iHeBzCNS2g7CGFM/OQyaLb04=",
    "cpf": "U2FsdGVkX19TNp6l+tzzGEFTGtXE9JHXM8whO+5NJ4M="
  },
  {
    "num_cand": "U2FsdGVkX1/xgOJxz/sq1AMZR8IxlhUq0S3Jz6zIfeo=",
    "cpf": "U2FsdGVkX1/csJQhEVVxIdAsS2lzKt0cYhu1KR1k7Js="
  },
  {
    "num_cand": "U2FsdGVkX1+lMC+EJAE0WyvH5FELGbi8WydXclHp4pU=",
    "cpf": "U2FsdGVkX19/Pp2xcDQF/RuTIRywcAWFHua1ItfT3+o="
  },
  {
    "num_cand": "U2FsdGVkX19S4vvQQSLEMN8VMCXlr/9q3xv7ke1O8E0=",
    "cpf": "U2FsdGVkX1/qY6reaJEeWMHW2lWQUGgYQhmI0asW6l8="
  },
  {
    "num_cand": "U2FsdGVkX19G90FllXZNhsk7GIrNpv/M4rXLY+xWQx0=",
    "cpf": "U2FsdGVkX19sZ/WqBGbRIgieaIPKEMLqPRkDnrKelCE="
  },
  {
    "num_cand": "U2FsdGVkX1/WErdKxRHWmfSIU9XaVrVfbsXhBTYcivo=",
    "cpf": "U2FsdGVkX18U4pNK+xyZuaootTc8/MAkaHQikXRx2uE="
  },
  {
    "num_cand": "U2FsdGVkX18Nb7IY9DqgxDbebFGJer/Y8gmB2i+2GBI=",
    "cpf": "U2FsdGVkX1+qGzmrv337ipx/jVE031kTeiUGiuTqgCQ="
  },
  {
    "num_cand": "U2FsdGVkX18hMm80Wd6RWOmZmP8hK90a08QIRZKcJ9Y=",
    "cpf": "U2FsdGVkX1/8asjyrLPCuQtLpL6SE9XZK3pbHHYXXUw="
  },
  {
    "num_cand": "U2FsdGVkX1+2cPuYF16mkAjp1sagvQuWMK5p/+bgHCc=",
    "cpf": "U2FsdGVkX19wXnv+Rar9mgZhnwGLcNYNkwa0zl4x0U4="
  },
  {
    "num_cand": "U2FsdGVkX19tRu6ZMhF7LB3ExMjXFaJ2Z+GW2+UkmbU=",
    "cpf": "U2FsdGVkX1+VduMTjeBZPQGtEQnxh9PRdOMLGY16RGA="
  },
  {
    "num_cand": "U2FsdGVkX186hQbAJxV0o2qaqDeu7u80jXmZjxXUI8w=",
    "cpf": "U2FsdGVkX1/Fe7FhWAlw0jd1/aDldYJqUQ4T4GSXvvs="
  },
  {
    "num_cand": "U2FsdGVkX1/HNWgbkxvblbFmtHAA37d74/GgoDeHjXY=",
    "cpf": "U2FsdGVkX1+Z1/WAtmB6wLO/KWYeBjFRU7ZGrayd8K0="
  },
  {
    "num_cand": "U2FsdGVkX19hxmHEnQsObAExfwjl1v6gTqXfeC5PjqM=",
    "cpf": "U2FsdGVkX1/LuUJHPU/0J+x/uOXEPuq6vJHFWzYz0iQ="
  },
  {
    "num_cand": "U2FsdGVkX1/vNuR5YienToTO2hjFLvejO6YXaqykJlA=",
    "cpf": "U2FsdGVkX1/rbaVZDD7pLMpNrL0jeQ/u6RxmOcVH84A="
  },
  {
    "num_cand": "U2FsdGVkX18bRxdGgX/I6cVCX58so2ynpHr0zONiNl0=",
    "cpf": "U2FsdGVkX19FKSQfgBMG9e0DOC0eR8xPs/W1fp4PX3I="
  },
  {
    "num_cand": "U2FsdGVkX1+J9ahXoeo5nKrdOwkrJb6xYAdimZ123EU=",
    "cpf": "U2FsdGVkX18I8+1adUtWAp9RZ7W1U7tpb47O3yD/Iq4="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g,'-');

            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2201/2201_rec_gabsx/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
